import React from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import SubHeading from '@components/sub-heading';
import ItemsTray from '@components/items-tray';
import ProfessionCard from './profession-card';

import { BlogHomepageCardDetailsType } from '../../types';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import { BrowserType } from '@constants/common';

interface ProfessionTrayProps {
  professionList: BlogHomepageCardDetailsType[];
  title: string;
  viewAllURL?: string;
  platform: PlatformType;
  browser: BrowserType;
}

const ProfessionsTray = (props: ProfessionTrayProps) => {
  const { professionList, title, viewAllURL, platform, browser } = props;

  return (
    <div>
      <div
        className={ivclass(
          'iv-grid iv-grid-cols-12 iv-col-span-12 iv-gap-[24px]',
        )}
      >
        <div className={ivclass('iv-col-span-12')}>
          <SubHeading title={title} viewAllURL={viewAllURL} />
        </div>
      </div>
      <div className={ivclass('md:iv-mt-10', 'md:iv-px-15', 'sm:iv-mt-30')}>
        {Array.isArray(professionList) && (
          <ItemsTray
            platform={platform}
            // sliderWrapperCls={ivclass('sm:iv-mr-[17px]')}
          >
            {professionList?.map(profession => (
              <div
                key={profession.id}
                className={ivclass(
                  'iv-relative',
                  'iv-mx-auto iv-w-[250px]',
                  'sm:iv-mr-[35px]',
                )}
              >
                <ProfessionCard
                  browser={browser}
                  platform={platform}
                  {...profession}
                />
              </div>
            ))}
          </ItemsTray>
        )}
      </div>
    </div>
  );
};

export default ProfessionsTray;
